import type { Components } from '@/api/generated/api';
import { ProductFeature } from '@/api/generated/api.enum';
import { useCheckoutOfferSource } from '@/composables/billing/useCheckoutOfferSource';
import BillingCheckoutDialog from '@/core/dialogs/billing-checkout/BillingCheckoutDialog.vue';
import { useDialog } from '@/core/dialogsystem/useDialog';

export function useSupportMeasureCheckout(): {
  showProductCheckoutDialog: (feature?: Components.Schemas.ProductFeature | null) => void;
} {
  const { getFeatureGateOfferSource } = useCheckoutOfferSource();
  const productCheckoutDialog = useDialog({ component: BillingCheckoutDialog, props: {} });

  const showProductCheckoutDialog = (
    feature: Components.Schemas.ProductFeature | null = ProductFeature.supportMeasures,
  ): void => {
    productCheckoutDialog.show({ feature, offerSource: getFeatureGateOfferSource(feature) });
  };

  return { showProductCheckoutDialog };
}
